import React, { useState, useEffect } from "react";
import BackNavigationPanel from "../../../../../ui/back-navigation-panel/BackNavigationPanel";
import MenuTable from "../../../../../ui/menu-table/MenuTable";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../..";
import { UpdateEmailNotificationStatusRequest, UpdateEmailNotificationStatusResponse, EmailTypes } from "../../../../../../utils/grpc/generated/Billsby.Protos/Messenger/private/companyconfig/companyconfig_pb";
import { updateEmailNotificationToggles, fetchEmailNotificationToggles } from "../../../../../../actions/emailRoutingActions";
import { useHistory } from "react-router";

const CancellationsMenu: React.FC = () => {
  const emailNotificationToggles = useSelector((state: AppState) => state.emailRoutingReducer.emailNotificationToggles);
  const currentCompanyId = useSelector((state: AppState) => state.auth.currentCompanyId);

  const dispatch = useDispatch<Function>();
  const history = useHistory();

  const [switchState, setSwitchState] = useState({
    subscriptionCancelled: false,
    addOnRemoved: false,
    allowanceRemoved: false
  });

  const updateData = async (updateEmailNotification: UpdateEmailNotificationStatusRequest) => {
    try {
      await (dispatch(updateEmailNotificationToggles(updateEmailNotification)) as { response: UpdateEmailNotificationStatusResponse });
      dispatch(fetchEmailNotificationToggles(Number(currentCompanyId)));
    }
    catch (err) { }
  }

  useEffect(() => {
    if (emailNotificationToggles.getEmailNotificationConfigsList().length) {
      let newState: typeof switchState = { ...switchState };
      emailNotificationToggles.getEmailNotificationConfigsList().forEach((elem) => {
        switch (elem.getEmailType()) {
          case EmailTypes.SUBSCRIPTION_CANCELLED:
            newState.subscriptionCancelled = elem.getIsEnabled();
            break;
          case EmailTypes.SUBSCRIPTION_ADDON_REMOVED:
            newState.addOnRemoved = elem.getIsEnabled();
            break;
          case EmailTypes.SUBSCRIPTION_ALLOWANCE_REMOVED:
            newState.allowanceRemoved = elem.getIsEnabled();
            break;
        }
      })
      setSwitchState(newState);
    }
  }, [emailNotificationToggles]);

  useEffect(() => {
    dispatch(fetchEmailNotificationToggles(Number(currentCompanyId)));
  }, []);

  return (
    <div>
      <BackNavigationPanel
        title={"EMAILS_MENU_RETENTION_CANCELLATIONS"} shouldTranslateTitle={true}
        onClick={() => history.push("/configuration/email-notifications/emails")}>
        <MenuTable
          data={[
            {
              title: "EMAILS_MENU_RETENTION_CANCELLATIONS_SUBSCRIPTION_CANCELLED",
              onClick: () => history.push("/configuration/email-notifications/emails/cancellations/subscription-cancelled-template"),
              canConfigureNotification: true,
              enableNotification: switchState.subscriptionCancelled,
              enableNotificationChange: (isChecked) => {
                setSwitchState({ ...switchState, subscriptionCancelled: isChecked });
                const updateEmailNotification = new UpdateEmailNotificationStatusRequest();
                updateEmailNotification.setCompanyId(Number(currentCompanyId));
                updateEmailNotification.setEmailType(EmailTypes.SUBSCRIPTION_CANCELLED);
                updateEmailNotification.setIsEnabled(isChecked);
                updateData(updateEmailNotification);
              }
            }, 
            {
              title: "EMAIL_TEMPLATE_REMOVE",
              onClick: () => history.push("/configuration/email-notifications/emails/cancellations/add-on-remove-template"),
              canConfigureNotification: true,
              enableNotification: switchState.addOnRemoved,
              enableNotificationChange: (isChecked) => {
                setSwitchState({ ...switchState, addOnRemoved: isChecked });
                const updateEmailNotification = new UpdateEmailNotificationStatusRequest();
                updateEmailNotification.setCompanyId(Number(currentCompanyId));
                updateEmailNotification.setEmailType(EmailTypes.SUBSCRIPTION_ADDON_REMOVED);
                updateEmailNotification.setIsEnabled(isChecked);
                updateData(updateEmailNotification);
              }
            },
            {
              title: "EMAIL_TEMPLATE_REMOVE_ALLOWANCE",
              onClick: () => history.push("/configuration/email-notifications/emails/cancellations/allowance-remove-template"),
              canConfigureNotification: true,
              enableNotification: switchState.allowanceRemoved,
              enableNotificationChange: (isChecked) => {
                setSwitchState({ ...switchState, allowanceRemoved: isChecked });
                const updateEmailNotification = new UpdateEmailNotificationStatusRequest();
                updateEmailNotification.setCompanyId(Number(currentCompanyId));
                updateEmailNotification.setEmailType(EmailTypes.SUBSCRIPTION_ALLOWANCE_REMOVED);
                updateEmailNotification.setIsEnabled(isChecked);
                updateData(updateEmailNotification);
              }
            }
          ]}
        />
      </BackNavigationPanel>
    </div>
  )
}

export default CancellationsMenu;
